import { Route, Routes } from 'react-router-dom';
import ComplaintManagementPage from '../pages/ComplaintManagementPage';
import ComplaintSettingsPage from '../pages/ComplaintSettingsPage';
import ShowTablePage from '../pages/ShowTablePage';
import NewComplaint from '../pages/NewComplaint';
function ComplaintRouter({ pageProps = {}, onPublish, onStepChange, children }) {
  const managementPage = children ?? <ComplaintManagementPage {...pageProps} />;

  return (
    <Routes>
      <Route path="/" element={managementPage} />
      <Route
        path="/settings/:systemId"
        element={
          <ComplaintSettingsPage
            onPublish={onPublish}
            onStepChange={onStepChange}
            company={pageProps.company}
            roleList={pageProps.roleList}
            userList={pageProps.userList}
            storeList={pageProps.storeList}
           
          />
        }
      />

      <Route path="complaintmanagement" element={<ShowTablePage company={pageProps.company} />} />
      <Route path="complaintmanagement/new/:complaintTypeId" element={<NewComplaint company={pageProps.company} storeList={pageProps.storeList} />} />
      <Route path="complaintmanagement/:complaintTypeId" element={<ShowTablePage company={pageProps.company} />} />
      <Route path="querymanagement" element={<ShowTablePage company={pageProps.company} />} />
      <Route path="querymanagement/new/:complaintTypeId" element={<NewComplaint company={pageProps.company} storeList={pageProps.storeList} />} />
      <Route path="querymanagement/:complaintTypeId" element={<ShowTablePage company={pageProps.company} />} />
      <Route path="*" element={managementPage} />
    </Routes>
  );
}

export default ComplaintRouter;
